import * as React from "react";
import {useEffect} from "react";
import {LogInForm} from "./Steps/LoginForm/LogInForm";
import {useLocation, useNavigate} from "react-router-dom";
import {LocalStorageEnum} from "../../enum/localStorage";
import {useAppSelector} from "../../app/hooks";
import {LoginFormAdmin} from "./Steps/LoginForm/LoginFormAdmin/LoginFormAdmin";

export const SignIn = () => {
    const {loginAdminToken} = useAppSelector(state => state.auth)
    const navigate = useNavigate();
    const {search} = useLocation()
    useEffect(() => {
        if (!localStorage.getItem(LocalStorageEnum.sawUpdate)) {
            navigate(`/welcome${search}`)
        }
    }, [])

    return <div className={'background body1'}>
        {loginAdminToken
            ?
            <LoginFormAdmin />
            :
            <LogInForm/>
        }
    </div>
}
export default SignIn
